import { authClient, API } from "../index";

// Count all marcas
export const countMarcas = () => {
  return authClient().get(`${API}/marca/count`);
};

// Get all marcas
export const getMarcas = () => {
  return authClient().get(`${API}/marca`);
};

// Get marca by id
export const getMarcaById = (id) => {
  return authClient().get(`${API}/marca/${id}`);
};

// Update marca
export const updateMarca = (id, marca) => {
  return authClient().put(`${API}/marca/${id}`, marca);
};

// Create marca
export const postMarca = (marca) => {
  return authClient().post(`${API}/marca`, marca);
};

// Delete marca
export const deleteMarca = (id) => {
  return authClient().delete(`${API}/marca/${id}`);
};

// Change status marca
export const changeStatusMarca = async (id, active) => {
  return authClient().put(`${API}/marca/change-status/${id}`, { active });
};

// Change status web marca
export const changeStatusWebMarca = async (id, web) => {
  return authClient().put(`${API}/marca/change-status-web/${id}`, { web });
};
